import axios from "axios";
import store from "@/store";
import router from '../config/router'
import { bus } from './bus';
import { Message } from 'element-ui';

let http = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    config.headers.Authorization = 'Bearer ' + window.localStorage.getItem("token");
    return config;
  },
  (err) => {
    Message({
      message: "网络错误",
      type: "warning",
    });
  }
);

// 响应拦截器
http.interceptors.response.use(
  (Response) => {
    if (Response.data.code === 200) {
      return Response.data;
    } else if (Response.data.code === 4001) {
      bus.$emit('openPop',Response.data.msg)
      // 未登录
      window.localStorage.clear();
      router.replace({ path: '/login' });
      return Response.data;
    } else {
      bus.$emit('openPop',Response.data.msg)
      return Response.data;
    }
    console.log(Response.data)
  },
  (error) => {
    console.error(error, "error");
  }
);

// post请求
const post = (url, data) => http.post(url, data);
const get = (url, data) => http.get(url, {
  params:{...data}
});
const host = "lexueyingyu.com/";
const wssUrl = 'wss://'+host+'wss';
const baseURL = "https://lexueyingyu.com/";

export default { post, get, baseURL,wssUrl };
